import { makeCookieSessionStorage } from "@lg-plus/landing-modules/cookie-storage";
import { debug } from "@lg-plus/landing-modules/debug";
import { makeHttpParamExtractor } from "@lg-plus/landing-modules/http-param-extractor";
import { extractRequestMetadata, } from "@lg-plus/landing-modules/lg-api";
import { getRuntimeConfig } from "../runtime-config/runtime-config.js";
export const handlePageRequest = async ({ req, query, res }, lgTriggerFunc) => {
    const headers = makeHttpParamExtractor(req.headers);
    const params = makeHttpParamExtractor(query);
    const sessionStorage = makeCookieSessionStorage(req, res);
    const sessionToken = sessionStorage.load();
    const domain = (headers("host") || "").split(":", 2)[0];
    const initialPayload = params("t");
    const lgResult = await lgTriggerFunc({
        initialPayload,
        sessionToken,
        request: extractRequestMetadata(req, query),
    });
    debug("LG SSR handler: got LG result command:", lgResult);
    if (lgResult.sessionToken) {
        sessionStorage.store(lgResult.sessionToken);
    }
    //TODO: auto-redirect based on command?
    //TODO: should we keep variants on the client side and restore them each time?
    return {
        props: {
            initialCommand: lgResult.command,
            ...(lgResult.flashMessage ? { flashMessage: lgResult.flashMessage } : {}),
            config: getRuntimeConfig(),
            traits: {
                domain,
                ...(lgResult.resolvedVariants || {}),
            },
        },
    };
};
